<template>
  <b-modal 
    size="xl"
    ref="modal" 
    :title="$t('stores.inventory.layout')"
  >
    <div v-for="zone in layout" :key="zone.code" class="bg-light border rounded p-3 mb-4">
      <h4>{{ zone.label }} ({{ zone.code }})</h4>
      <table class="table table-bordered table-sm mb-0 bg-white" :style="`max-width:${(100/maxRacks) * zone.racks.length}%;table-layout: fixed;`">
        <thead>
          <tr>
            <th v-for="rack in zone.racks" :key="rack.code">{{ rack.code }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="s in zone.shelves" :key="s">
              <td 
                v-for="rack in zone.racks" 
                :key="rack.code" 
                class="position-relative overflow-hidden pt-4 overflow-hidden text-center text-nowrap" 
              >
                <b-badge class="position-absolute" style="top:-2px;left:-2px" :variant="rack.shelves[s-1].count > 0 ? 'success' : 'secondary'">
                  {{ `${rack.shelves[s-1].code}` }}
                </b-badge>
                <h4 v-if="rack.shelves[s-1].count > 0">
                  
                  {{ $t('stores.inventory.count', { count: rack.shelves[s-1].count }) }}
                </h4>
              </td>
          </tr>
        </tbody>
      </table>
    </div>

    <template #modal-footer>
      <b-button @click="close()">{{$t('common.close')}}</b-button>
    </template>
  </b-modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: 'InventoryLayoutModal',
  extends: Modal,
  components: {
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
    packages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    layout() {
      return this.location.layout.map(zone => ({
        ...zone,
        count: this.packages.filter(p => p.locker_number?.startsWith(zone.code)).length,
        racks: Array.from({ length: zone.racks }).map((_,i) => {
          const rackCode = `${zone.code}-${this.zeroPad(i+1)}`
          return {
            code: rackCode,
            count: this.packages.filter(p => p.locker_number?.startsWith(rackCode)).length,
            shelves: Array.from({ length: zone.shelves }).map((_,j) => {
              const shelfCode = `${rackCode}-${j+1}`
              return {
                code: shelfCode,
                count: this.packages.filter(p => p.locker_number?.startsWith(shelfCode)).length,
              }
            })
          }
        })
      }))
    },
    maxRacks() {
      return Math.max(...this.layout.map(z => z.racks.length))
    },
  },
  methods:{
    zeroPad(num) {
        return String(num).padStart(2, '0');
    }
  }
}
</script>